module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/166.ecbbdfd4.png";